/**
 * Fast & Furious Landing Page
 */
(function () {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHeroVideos() {
    document.querySelectorAll('[data-fnf-hero] video').forEach((video) => {
      if (REDUCED) {
        video.pause();
        video.removeAttribute('autoplay');
        return;
      }
      video.muted = true;
      video.playsInline = true;
      const play = video.play();
      if (play && typeof play.catch === 'function') play.catch(() => {});
    });
  }

  function goToHash(hash, { updateHash = true } = {}) {
    if (!hash || hash === '#') return false;
    const el = document.querySelector(hash);
    if (!el) return false;
    el.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
    if (updateHash) history.replaceState(null, '', hash);
    return true;
  }

  function initSmoothAnchors() {
    document.querySelectorAll('.fnf-lp a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (e) => {
        const id = link.getAttribute('href');
        if (!id || id === '#') return;
        if (!document.querySelector(id)) return;
        e.preventDefault();
        goToHash(id);
      });
    });
  }

  function initFaq(root) {
    root.querySelectorAll('[data-fnf-faq-q]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.painta-faq__item');
        const answer = item && item.querySelector('[data-fnf-faq-a]');
        if (!answer) return;
        const open = btn.getAttribute('aria-expanded') === 'true';
        root.querySelectorAll('[data-fnf-faq-q]').forEach((other) => {
          other.setAttribute('aria-expanded', 'false');
          const otherAnswer = other.closest('.painta-faq__item')?.querySelector('[data-fnf-faq-a]');
          if (otherAnswer) otherAnswer.hidden = true;
        });
        if (!open) {
          btn.setAttribute('aria-expanded', 'true');
          answer.hidden = false;
        }
      });
    });
  }

  function initLucideIcons() {
    const mount = () => {
      if (!window.lucide || typeof window.lucide.createIcons !== 'function') return false;
      window.lucide.createIcons({
        attrs: {
          'stroke-width': 1.75,
          stroke: 'currentColor',
          fill: 'none',
        },
      });
      return true;
    };

    if (mount()) return;
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (mount() || tries > 40) clearInterval(timer);
    }, 50);
  }

  function formatMoney(cents) {
    return (Number(cents) / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
    });
  }

  function initBundle(root) {
    const picks = new Map();
    const tier1Count = Number(root.dataset.tier1Count || 3);
    const tier2Count = Number(root.dataset.tier2Count || 4);
    const tier1Percent = Number(root.dataset.tier1Percent || 15);
    const tier2Percent = Number(root.dataset.tier2Percent || 20);
    const tier1Code = root.dataset.tier1Code || 'FNF15';
    const tier2Code = root.dataset.tier2Code || 'FNF20';

    const countEl = root.querySelector('[data-fnf-count]');
    const hintEl = root.querySelector('[data-fnf-hint]');
    const picksEl = root.querySelector('[data-fnf-picks]');
    const subtotalEl = root.querySelector('[data-fnf-subtotal]');
    const saveRow = root.querySelector('[data-fnf-save-row]');
    const saveLabel = root.querySelector('[data-fnf-save-label]');
    const saveEl = root.querySelector('[data-fnf-save]');
    const totalEl = root.querySelector('[data-fnf-total]');
    const codeRow = root.querySelector('[data-fnf-code-row]');
    const codeBtn = root.querySelector('[data-fnf-copy-code]');
    const addBtn = root.querySelector('[data-fnf-add]');
    const addLabel = addBtn ? addBtn.textContent : 'Set in den Warenkorb';

    function currentTier(count) {
      if (count >= tier2Count) {
        return { percent: tier2Percent, code: tier2Code, key: 2 };
      }
      if (count >= tier1Count) {
        return { percent: tier1Percent, code: tier1Code, key: 1 };
      }
      return { percent: 0, code: '', key: 0 };
    }

    function render() {
      const count = picks.size;
      const subtotal = [...picks.values()].reduce((sum, item) => sum + item.price, 0);
      const tier = currentTier(count);
      const save = Math.round(subtotal * (tier.percent / 100));
      const total = subtotal - save;

      if (countEl) countEl.textContent = String(count);
      if (picksEl) {
        picksEl.innerHTML = [...picks.values()]
          .map((item) => `<li><span>${item.title}</span><span>${formatMoney(item.price)}</span></li>`)
          .join('');
      }
      if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);
      if (totalEl) totalEl.textContent = formatMoney(total);

      if (saveRow && saveEl && saveLabel) {
        if (tier.percent > 0) {
          saveRow.hidden = false;
          saveLabel.textContent = `${tier.percent}% Rabatt`;
          saveEl.textContent = `−${formatMoney(save)}`;
        } else {
          saveRow.hidden = true;
        }
      }

      if (codeRow && codeBtn) {
        if (tier.code) {
          codeRow.hidden = false;
          codeBtn.textContent = tier.code;
          codeBtn.dataset.code = tier.code;
        } else {
          codeRow.hidden = true;
        }
      }

      root.querySelectorAll('.fnf-bundle__tier').forEach((el) => {
        el.classList.toggle('is-active', Number(el.dataset.tier) === tier.key);
      });

      if (hintEl) {
        if (count === 0) {
          hintEl.textContent = `Wähle mindestens ${tier1Count} Modelle für ${tier1Percent}% Rabatt.`;
        } else if (count < tier1Count) {
          hintEl.textContent = `Noch ${tier1Count - count} bis ${tier1Percent}% Rabatt.`;
        } else if (count < tier2Count) {
          hintEl.textContent = `Noch ${tier2Count - count} bis ${tier2Percent}% Rabatt.`;
        } else {
          hintEl.textContent = `${tier2Percent}% Rabatt aktiv – Code ${tier2Code} gilt an der Kasse.`;
        }
      }

      if (addBtn) addBtn.disabled = count < tier1Count;
    }

    root.querySelectorAll('[data-fnf-pick]').forEach((card) => {
      card.addEventListener('click', () => {
        if (card.disabled) return;
        const id = card.dataset.productId;
        if (picks.has(id)) {
          picks.delete(id);
          card.classList.remove('is-selected');
        } else {
          picks.set(id, {
            productId: id,
            variantId: Number(card.dataset.variantId),
            price: Number(card.dataset.price),
            title: card.dataset.title,
          });
          card.classList.add('is-selected');
        }
        render();
      });
    });

    if (codeBtn) {
      codeBtn.addEventListener('click', async (e) => {
        e.stopPropagation();
        const code = codeBtn.dataset.code;
        if (!code) return;
        const original = codeBtn.textContent;
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(code);
          }
          codeBtn.textContent = 'Kopiert';
          setTimeout(() => {
            codeBtn.textContent = original;
          }, 1400);
        } catch (err) {
          codeBtn.textContent = original;
        }
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        if (addBtn.disabled || picks.size < tier1Count) return;
        const tier = currentTier(picks.size);
        const bundleId = `FNF-${Date.now()}`;
        const items = [...picks.values()].map((item) => ({
          id: item.variantId,
          quantity: 1,
          properties: {
            _bundle_id: bundleId,
            _bundle_count: String(picks.size),
            _bundle_discount: String(tier.percent),
            _discount_code: tier.code,
            'Bundle': `${tier.percent}% Fast & Furious Set`,
          },
        }));

        const original = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = '…';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!res.ok) throw new Error('add failed');

          if (tier.code) {
            try {
              await fetch(`/discount/${encodeURIComponent(tier.code)}`, {
                credentials: 'same-origin',
                redirect: 'manual',
              });
            } catch (discountErr) {
              /* Code gilt trotzdem an der Kasse, wenn er im Admin angelegt ist */
            }
          }

          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const cartType = window.themeVariables?.settings?.cartType;
          const openDrawer = cartType === 'drawer';

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:updated', { bubbles: true, detail: { cart } })
          );
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart, openMiniCart: openDrawer },
            })
          );

          if (openDrawer) {
            const toggle = document.querySelector(
              '[data-action="toggle-drawer"][data-drawer="cart"]'
            );
            if (toggle && !toggle.classList.contains('is-active')) {
              setTimeout(() => toggle.click(), 120);
            }
          }

          addBtn.textContent = 'Set hinzugefügt';
          setTimeout(() => {
            addBtn.textContent = original;
            addBtn.disabled = picks.size < tier1Count;
          }, 2000);
        } catch (err) {
          addBtn.textContent = original;
          addBtn.disabled = false;
        }
      });
    }

    render();
  }

  function init() {
    initHeroVideos();
    document.querySelectorAll('[data-fnf-faq]').forEach(initFaq);
    document.querySelectorAll('[data-fnf-bundle]').forEach(initBundle);
    initLucideIcons();
    initSmoothAnchors();

    const hash = window.location.hash;
    if (hash && document.querySelector(hash)) {
      goToHash(hash, { updateHash: false });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
